export default "__VITE_ASSET__RWdTwSa6__"